import React, { useState } from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import { MdOutlineQuiz } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';

const MnthEndFAQ = () => {
    const [isActive, setIsActive] = useState(false);
    const navigate = useNavigate();

    return (
        <div className='faqContainer'>
            <div className="accordion-title d-flex justify-content-between align-items-center" onClick={() => setIsActive(!isActive)}>

                <div className='faq-container d-flex'>
                    <div className='faq-icon-contaner'>
                        <MdOutlineQuiz size={20} color="#FFFFFF" style={{opacity: '0.5'}}/>
                    </div>
                    <span className='faqTitle' style={{color: '#FFFFFF'}}>FAQs</span>
                </div>

                <div className="col-1 d-flex justify-content-end"><span className="row toggleBtn">{isActive ? <CgClose color="#FFFFFF" size={20} /> : <BsPlusLg color="#FFFFFF" size={20} />}</span></div>
            </div>
            {isActive && <div className="accordion-content subText">
                <div>
                    <ul className='termAndConditionPoints mt-4'>
                    <li>
                        <p className='FAQ-Question' style={{color: '#FFFFFF'}}>What is the 5% rewards campaign on Elite Card spends?</p>
                        <p className='paragraph' style={{color: '#FFFFFF', opacity: 0.5}}>Users earn 5% rewards on every eligible Elite card spend.</p>
                    </li>
                        <a style={{ color: '#D1964A', textDecoration: 'none', marginBottom: '0px' }} onClick={() => { navigate('/monthBonanzaFaq') }} className='tAndc'>View more <FiChevronRight style={{width: '18px', height: '18px', color:'#D1964A'}} className='back-button-icon' /></a>
                    </ul>
                </div>
            </div>}
        </div>
    );
}

export default MnthEndFAQ;
